import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';

import { ApiResponse } from './promocodes.entity';

@Injectable({ providedIn: 'root' })
export class PromocodesService extends AbstractService {
  protected override prefix = '/bonuses';

  usePromocode(code: string): Observable<ApiResponse.UsedPromocode> {
    return this.post<ApiResponse.UsedPromocode>('/codes/use', { code }, { throwError: true });
  }

  getUserStatus(): Observable<ApiResponse.UserStatus> {
    return this.get<ApiResponse.UserStatus>('/promocodes/status');
  }

  checkStatus(): Observable<ApiResponse.RecheckedProfile> {
    return this.post<ApiResponse.RecheckedProfile>('/promocodes/status/check', { }, { throwError: true });
  }
}